module.exports = __webpack_public_path__ + "media/icon/icon-LINE-edc59aed.svg";